import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const FamilySpaces = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const images = [
    {
      url: 'https://customer-assets.emergentagent.com/job_hotel-redesign-1/artifacts/fgsv7l3t_0.jpg',
      alt: 'Espacios familiares Hotel Montecarlo 1'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hotel-redesign-1/artifacts/xrsek01m_2.jpg',
      alt: 'Espacios familiares Hotel Montecarlo 2'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hotel-redesign-1/artifacts/4g4dn985_3.jpg',
      alt: 'Espacios familiares Hotel Montecarlo 3'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hotel-redesign-1/artifacts/fbcbwnkn_4.jpg',
      alt: 'Espacios familiares Hotel Montecarlo 4'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hotel-redesign-1/artifacts/yj26u50a_4.5.jpg',
      alt: 'Espacios familiares Hotel Montecarlo 5'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hotel-redesign-1/artifacts/jq844f8d_5.jpg',
      alt: 'Espacios familiares Hotel Montecarlo 6'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hotel-redesign-1/artifacts/p8alrxhk_6.jpg',
      alt: 'Espacios familiares Hotel Montecarlo 7'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hotel-redesign-1/artifacts/eiskerem_7.jpg',
      alt: 'Espacios familiares Hotel Montecarlo 8'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hotel-redesign-1/artifacts/yvkvcv5m_13.jpg',
      alt: 'Espacios familiares Hotel Montecarlo 9'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hotel-redesign-1/artifacts/athckmkh_15.jpg',
      alt: 'Espacios familiares Hotel Montecarlo 10'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hotel-redesign-1/artifacts/9th06n6z_17.jpg',
      alt: 'Espacios familiares Hotel Montecarlo 11'
    }
  ];

  // Auto-play cada 3 segundos
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(timer);
  }, [images.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
            Espacios diseñados para toda la familia
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Descubre nuestras áreas comunes pensadas para que disfrutes momentos inolvidables
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="relative overflow-hidden rounded-2xl shadow-2xl">
            {/* Contenedor con altura ajustada para escritorio */}
            <div className="relative h-96 md:h-[500px]">
              {images.map((image, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-opacity duration-500 ${
                    currentSlide === index ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  <img
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover object-center"
                    style={{
                      objectFit: 'cover',
                      objectPosition: 'center'
                    }}
                  />
                </div>
              ))}
            </div>

            {/* Botones de navegación */}
            <button
              onClick={prevSlide}
              className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/30 backdrop-blur-sm hover:bg-white/50 text-white p-3 rounded-full transition-all duration-200 z-10"
              aria-label="Anterior"
            >
              <ChevronLeft className="w-6 h-6" />
            </button>
            <button
              onClick={nextSlide}
              className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/30 backdrop-blur-sm hover:bg-white/50 text-white p-3 rounded-full transition-all duration-200 z-10"
              aria-label="Siguiente"
            >
              <ChevronRight className="w-6 h-6" />
            </button>
          </div>

          {/* Indicadores de posición (dots) */}
          <div className="flex justify-center mt-6 gap-2 flex-wrap">
            {images.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`h-3 rounded-full transition-all duration-300 ${
                  currentSlide === index ? 'w-8 bg-blue-900' : 'w-3 bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Ir a imagen ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FamilySpaces;
